import { IconX } from "@tabler/icons";

import { useAppDispatch } from "@sso/hooks/useRedux";
import { closeDialog } from "@sso/store/slices/dialog";
import { Divider } from "@sso/ui/Divider";
import { Flex } from "@sso/ui/FlexBox";
import { IconButton } from "@sso/ui/IconButton";
import { Typography } from "@sso/ui/Typography";

interface DialogHeaderProps {
  title: string;
  actionButtons?: JSX.Element;
}

export const DialogHeader = ({ title, actionButtons }: DialogHeaderProps) => {
  const dispatch = useAppDispatch();
  const handleCloseDialog = () => dispatch(closeDialog());

  return (
    <Flex padding="1rem" width="100%" justify="space-between">
      <Typography as="h2" size="1.25rem" fontWeight={500} lineHeight={1.6} margin="0">
        {title}
      </Typography>
      <Flex>
        {actionButtons && actionButtons}
        {actionButtons && <Divider direction="v" height="40px" />}
        <IconButton title="Close Dialog">
          <IconX size={25} onClick={handleCloseDialog} />
        </IconButton>
      </Flex>
    </Flex>
  );
};
